<div class="col-lg-12 field-style">
  <div _ngcontent-fvk-c300="">
    <h2>Filter</h2>
  </div>
  <div class="form-hgt">
    <form [formGroup]="filterForm">
      <div class="mb-2">
        <p-iconfield>
          <p-inputicon styleClass="pi pi-search" />
          <input
            pInputText
            jniAutoCompleteBlocker
            name="pName"
            formControlName="title"
            type="text"
            class="form-control"
            id="pName"
            placeholder="Search by Title" />
        </p-iconfield>
      </div>
      <div class="form-group has-float-label mb-2">
        <label class="form-label">State</label>
        <p-select
          formControlName="state"
          [options]="stateList"
          [filter]="true"
          [showClear]="true">
        </p-select>
      </div>
      <div class="form-group has-float-label mb-2">
        <label class="form-label">Linked Project</label>
        <input
          pInputText
          jniAutoCompleteBlocker
          jniNumberOnly
          name="linkedProject"
          formControlName="linkedProject"
          type="text"
          class="form-control"
          id="pName"
          placeholder="Search by Project ID" />
      </div>
      <div class="form-group has-float-label mb-2 p-input-icon-right w-100">
        <label class="form-label">Due Date</label>
        <i class="pi pi-calendar"></i>

        <p-datePicker
          jniAutoCompleteBlocker
          [selectOtherMonths]="true"
          appendTo="body"
          [inputStyle]="{ height: '30px' }"
          [style]="{ width: '100%' }"
          [showButtonBar]="false"
          formControlName="dueDate"
          [hourFormat]="'24'">
        </p-datePicker>
      </div>
      <div class="form-group has-float-label mb-2">
        <label class="form-label">Assigned To</label>
        <p-select
          formControlName="assignedTo"
          [options]="assignedUserList"
          optionLabel="name"
          optionValue="name">
        </p-select>
      </div>
      <div class="form-group has-float-label mb-2">
        <label class="form-label">Priority</label>
        <p-select [options]="priorityTypeList" formControlName="priority">
          <ng-template ng-label-tmp let-item="item">
            <div
              [style.backgroundColor]="
                getIdByTitle(item) === '1'
                  ? '#ff4d4d'
                  : getIdByTitle(item) === '2'
                    ? '#ffc966'
                    : getIdByTitle(item) === '3'
                      ? '#6666ff'
                      : '#ffffff'
              ">
              {{ item }}
            </div>
          </ng-template>
          <ng-template ng-option-tmp let-item="item" let-index="index">
            <div
              [style.backgroundColor]="
                getIdByTitle(item) === '1'
                  ? '#ff4d4d'
                  : getIdByTitle(item) === '2'
                    ? '#ffc966'
                    : getIdByTitle(item) === '3'
                      ? '#6666ff'
                      : '#ffffff'
              ">
              {{ item }}
            </div>
          </ng-template>
        </p-select>
      </div>
      <div class="form-group has-float-label mb-2 p-input-icon-right w-100">
        <label class="form-label">Remind Me</label>
        <i class="pi pi-calendar"></i>
        <p-datePicker
          jniAutoCompleteBlocker
          [selectOtherMonths]="true"
          appendTo="body"
          [inputStyle]="{ height: '30px' }"
          [style]="{ width: '100%' }"
          [showButtonBar]="false"
          formControlName="remindMe"
          [hourFormat]="'24'">
        </p-datePicker>
      </div>
      <div class="form-group has-float-label mb-2">
        <label class="form-label">Job Name</label>
        <input
          pInputText
          jniAutoCompleteBlocker
          name="pName"
          formControlName="jobName"
          type="text"
          class="form-control"
          id="pName"
          placeholder="Search by Job Name" />
      </div>
      <div class="form-group has-float-label mb-2">
        <label class="form-label">Tag</label>
        <p-select
          formControlName="selectTag"
          [options]="tagList"
          optionLabel="tagTitle"
          optionValue="tagId"
          [filter]="true"
          [showClear]="true">
        </p-select>
      </div>
    </form>
  </div>
  <div class="col-lg-12 mt-3 d-flex gap-3 justify-content-end">
    <p-button
      label="Cancel"
      (click)="close()"
      variant="outlined"
      severity="secondary" />

    <p-button label="Search" (click)="getFormFilteredValues()" />

    <!-- <button
      pButton
      type="button"
      label="Cancel"
      class="p-button-secondary p-button-sm p-button-outlined"
      (click)="close()"></button>
    <button
      pButton
      type="button"
      (click)="getFormFilteredValues()"
      label="Search"
      class="p-button-sm"></button> -->
  </div>
</div>
